import { render, staticRenderFns } from "./MyCode.vue?vue&type=template&id=471fa258&"
import script from "./MyCode.vue?vue&type=script&lang=js&"
export * from "./MyCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports